/** Slack frame chrome. */
export default {
  loadingMessages: "Loading messages",
  noMessages: "No messages yet",
  writing: "Writing",
  replies: { one: "{count} reply", other: "{count} replies" },
} as const;
